export const REPAIR_MODEL = 'gpt-5.4-nano' as const;
export const MAX_ISSUES_PER_BATCH = 20;
export const REPAIR_DECIMAL_PLACES = 2;
export const NUMERIC_TOLERANCE = 0.0001;
